import Container from 'react-bootstrap/Container';
import styled from 'styled-components';

import Breadcrumbs from '@components/breadcrumbs/Breadcrumbs';
import BaseText from '@components/typography/BaseText';

export const StyledView = styled(Container)`
	color: ${props => props.theme.colors.textColor};
	padding-top: 2.5rem;
	height: 100%;
	${p =>
		p.maxwidth &&
		`
		max-width: ${p.maxwidth}px;
	`}
`;

const StyledHeadingWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr auto;
	column-gap: 1rem;

	@media (max-width: 767.98px) {
		grid-template-columns: 1fr auto;
		margin-bottom: 1.5rem;

		& > :nth-child(1) {
			grid-column: 1 / 3;
		}
		& > :nth-child(2) {
			justify-self: start;
			grid-row: 2 / 3;
		}
	}
`;

const View = ({
	title = '',
	subtitle = null,
	maxWidth = null,
	headingComponent = null,
	breadcrumbs,
	children,
}) => {
	return (
		<StyledView maxwidth={maxWidth}>
			{breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
			<StyledHeadingWrapper>
				{title && (
					<div className="mb-4">
						<h1 className={subtitle ? 'mb-1' : 'mb-0'}>{title}</h1>
						{subtitle && (
							<BaseText size="xs" type="secondary" style={{ display: 'block' }}>
								{subtitle}
							</BaseText>
						)}
					</div>
				)}
				{headingComponent && headingComponent}
			</StyledHeadingWrapper>
			{children}
		</StyledView>
	);
};

export default View;
